import client from '@/store/client'
import qs from 'query-string'
import { parseString } from 'xml2js'
import _ from 'lodash'
import parseData from '../util/parsedata'

const getDefaultState = () => {
  return {
    search: '',
    status: '1',
    pRetailers: true,
    retailers: false,
    merchants: false,
    searchRes: [],
    searched: false,
    statusTypes: []
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    SET_STATUS_TYPES: async function({ commit }){
      const apiResults = await client.post('/v1/Lookup.asmx/GetRowStatusTypes', qs.stringify(this.getters['traceToken']))
      commit('setStatusTypes', await parseData(apiResults.data))
    },
    SEARCH_CLIENT: async function({ commit }){
      this.dispatch('searchTableData/TABLE_DATA_RESET')
      this.dispatch('searchTableData/SET_TABLE_CARD_HEADER', this.getters['search/currentSearch'])
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Getting Data',
          subdetail: 'Please wait',
        })        
        const apiResults = await Promise.all(this.getters['search/searchURLs'].map(url => client.post(url, qs.stringify(this.getters['search/currentSearch']))))
        let resData = []
        apiResults.forEach( (result) => {
          parseString(result.data, ( err, res ) =>{
            resData.push( res.content.collection[0].data )
          })
        })
        resData = resData.filter( res => res != undefined)
        const searchResults = []
        resData.forEach(element => {
          element.forEach( item => {
            searchResults.push(item.$)
          })
        });
        commit('setSearched')
        commit('setSearchResults', searchResults)
        this.dispatch('searchTableData/SET_PRETAILERS')
        this.dispatch('searchTableData/SET_RETAILERS')
        this.dispatch('searchTableData/SET_MERCHANTS')
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Data Received',
          subdetail: '',
        })    
      }
      catch(err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })    

      }
    },
  },
  getters: {
    searchURLs: (state, getters) => _.keys(getters['searchOptions']).filter(option => state[option] == true).map(key => getters['allSearchURLs'][key]),
    allSearchURLs: () => {
      return {
        pRetailers: '/v1/PRetailer.asmx/FindPRetailers',
        retailers: '/v1/Retailers.asmx/FindRetailers',
        merchants: '/v1/Merchant.asmx/FindMerchants',
      }
    },
    searchOptions: state => _.pick(state, ['pRetailers', 'retailers', 'merchants']),
    currentSearch: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        status: state.status,
        search: state.search    
      }
    }
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    setStatusTypes: function( state, data ){
      state.statusTypes = data
    },
    setSearchResults: function( state, data ) {
      state.searchRes = data
    },
    setSearched: function( state ) {
      state.searched = true
    }
  },
}
